import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../../components/Layout';
import BrandManagerHome from './BrandManagerHome';
import HotelManagerHome from './HotelManagerHome';
import MobileHome from './MobileHome';
import NoRoleHome from './NoRoleHome';
import TourManagerHome from './TourManagerHome';
import TravelManagerHome from './TravelManagerHome';


class Home extends React.Component {

  render() {
    if (this.props.perms.includes('travel_management')){
      return (
        <Layout>
          <TravelManagerHome />
        </Layout>
      )
    }
    if (this.props.perms.includes('brand_management')){
      return (
        <Layout>
          <BrandManagerHome />
        </Layout>
      );
    }
    if (this.props.perms.includes('hotel_management')){
      return (
        <Layout>
          <HotelManagerHome />
        </Layout>
      );
    }
    if (this.props.perms.includes('tour_management')){
      return (
        <Layout>
          <TourManagerHome />
        </Layout>
      );
    }
    if (this.props.perms.includes('mobile_access')){
      return (
        <Layout>
          <MobileHome />
        </Layout>
      );
    }
    return (
      <Layout>
        <NoRoleHome />
      </Layout>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// src/routes/home/components/Home.js